import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthProvider";
import { useApp } from "../../AppProvider";
import { Button, Field } from "../../Components/UI/ui";
import LogoWithName from "../../assets/LogoName.svg";
import { fullName } from "../../lib/lab";

// Shown instead of the app while `mustChangePassword` is set (a login created
// or reset by an admin). Navigation is blocked until POST /auth/changePassword succeeds.
const ForcePasswordChange = () => {
  const { user, changePassword, logout } = useAuth();
  const { toast } = useApp();
  const navigate = useNavigate();
  const [pw, setPw] = useState({ old: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async () => {
    setErr(null);
    if (!pw.old || !pw.next) return setErr("Enter the temporary password and a new one");
    if (pw.next.length < 6) return setErr("New password must be at least 6 characters");
    if (pw.next === pw.old) return setErr("New password must differ from the temporary one");
    if (pw.next !== pw.confirm) return setErr("New passwords do not match");
    setBusy(true);
    try {
      await changePassword(pw.old, pw.next);
      toast.success("Password set — welcome!");
      navigate("/", { replace: true });
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="lab-modal-bg" style={{ position: "fixed", inset: 0 }}>
      <div className="lab-modal sm" style={{ padding: 0 }}>
        <div className="lab-modal__head" style={{ flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
          <img src={LogoWithName} alt="" style={{ height: 36 }} />
          <h3>Set your password</h3>
          <span className="lab-muted">Hi {fullName(user?.staff?.name)} — your login was created with a temporary password. Choose your own before continuing.</span>
        </div>
        <div className="lab-modal__body">
          <Field label="Temporary password"><input type="password" className="lab-input w-full" value={pw.old} autoFocus autoComplete="current-password" onChange={(e) => setPw({ ...pw, old: e.target.value })} /></Field>
          <Field label="New password" hint="At least 6 characters"><input type="password" className="lab-input w-full" value={pw.next} autoComplete="new-password" onChange={(e) => setPw({ ...pw, next: e.target.value })} /></Field>
          <Field label="Confirm new password"><input type="password" className="lab-input w-full" value={pw.confirm} autoComplete="new-password" onKeyDown={(e) => e.key === "Enter" && submit()} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} /></Field>
          {err && <span className="lab-danger-text">{err}</span>}
        </div>
        <div className="lab-modal__foot">
          <Button variant="ghost" onClick={async () => { await logout(); navigate("/login", { replace: true }); }}>Log out</Button>
          <Button variant="primary" loading={busy} onClick={submit}>Save password</Button>
        </div>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
